module.exports = __webpack_public_path__ + "static/media/grayBankslip.3043e3c0.svg";